module.exports = __webpack_public_path__ + "static/media/icon-camel-outline.6a34c934.svg";